import React, { FC } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import DPSelect from "Components/DP/DPSelect/DPSelect";

export interface PayGroupSelectorProps {
  selectedIndex: number;
  onIndexChanged: (index: number) => void;
  payGroups: string[];
}

const PayGroupSelector: FC<PayGroupSelectorProps> = ({
  selectedIndex,
  onIndexChanged,
  payGroups,
}) => {
  return (
    <DPSelect
      inputLabel="Pay Group:"
      selectedIndex={selectedIndex}
      onIndexChanged={onIndexChanged}
    >
      {payGroups.map((payGroup, idx) => (
        <MenuItem key={idx} value={idx}>
          {payGroup}
        </MenuItem>
      ))}
    </DPSelect>
  );
};

export default PayGroupSelector;
